export default __webpack_public_path__ + "static/3-bbed6bd0da43d67c76c3d0be3b3f713b.jpeg";